import { PUBLIC_CARRIER_COOKIE } from 'core/domain/Carrier'
import { type CookieClient, cookieClient } from 'core/infra/cookie'
import { ShipperGuideClient } from 'core/infra/http/ShipperGuideClient'

import { SpotQuoteRepository } from '../infra/SpotQuoteRepository'

export type GetBulkSpotQuoteFactoryDependencies = {
  spotQuoteRepository: SpotQuoteRepository
  cookie: CookieClient
}

export function getBulkSpotQuoteFactory({
  spotQuoteRepository,
  cookie,
}: GetBulkSpotQuoteFactoryDependencies) {
  return async function getBulkQuoteImpl(id: string, config?: { signal?: AbortSignal }) {
    const bulkQuote = await spotQuoteRepository.getBulkSpotQuoteById(id, config)

    cookie.setCookie(PUBLIC_CARRIER_COOKIE, bulkQuote.carrier)

    return bulkQuote
  }
}

export function getBulkSpotQuote(id: string, config?: { signal?: AbortSignal }) {
  const httpClient = new ShipperGuideClient()
  const spotQuoteRepository = new SpotQuoteRepository({ httpClient })
  const newGetBulkSpotQuote = getBulkSpotQuoteFactory({ spotQuoteRepository, cookie: cookieClient })

  return newGetBulkSpotQuote(id, config)
}
